import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import Text from "../../Components/FormControl/Text/Text";
import Select from "../../Components/FormControl/Select/Select";
import { AppContext } from "./../../Context/AppContext";
import { getAccessByModuleName } from "./../../Routes/Routes";
import { DEFAULT_COUNTRY_CODE, DEFAULT_COUNTRY_CODE_NAME, MODULES, DEFAULT_TIMEZONE } from "./../../Helpers/Constants";
import { getProfile, getTimezones } from "../../api/user";
import { formatUsPhone, checkValidEmailId } from "./../../Hooks/commanUtility";
import PhoneNumber from "Components/FormControl/PhoneNumber/PhoneNumber";

import { storeDetails, addStoreDetails, updateStoreDetails,updateStoreWiseBurqStatus, checkStoreWithSameZipCode } from "api/stores";
import moment from "moment";
import { convertDateTime } from "Helpers/date";
import StoreSettingOpenCloseTime from "./StoreSettingOpenCloseTime";
import SwitchBox from "Components/FormControl/SwitchBox/SwitchBox";
import style from "Components/Settings/index.module.scss"

import { useNavigate } from "react-router-dom";

import Warning from "Components/Modal/Warning/warning";

/**
 * Split a sentinel-UTC time column ("HH:mm:ss") into the hrs/min/meridiem the
 * store-hours pickers use. Pinned to 2026-01-01 so DST never shifts the value.
 */
const splitSentinelTime = (value) => {
  let [hrs, min] = value.split(":");
  if (hrs.length === 1) hrs = "0" + hrs;
  const twentyFourFormat = moment(hrs + ":" + min, "HH:mm").format("hh:mm A");
  const converted = convertDateTime("20260101 " + twentyFourFormat, "format7temp", "yyyyMMdd hh:mm a");
  return {
    cutoff_hrs: converted.toFormat("hh"),
    cutoff_min: converted.toFormat("mm"),
    cutoff_meridiem: converted.toFormat("a"),
  };
};

const InfoSettings = (props) => {
  const navigate = useNavigate();

  const { showToastMessage, setIsLoading, modules } = useContext(AppContext);
  const [storeSettingInfo, setStoreSettingInfo] = useState({
    title: "",
    local_phone1: "",
    local_phone2: "",
    fax: "",
    email_id_main: "",
    email_id_replay_to: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    state: "",
    state_matches: "",
    zip: "",
    business_hours: "",
    location_hours_line1: "",
    location_hours_line2: "",
    instagram_id: "",
    instagram_credentials: "",
    burq_status:false,
    onfleet_team_id:"",
    burq_account_id:"",
    is_burq_account:false,
    apply_daily_overtime:true,
    require_lunch_break:false,
    tax_rate:"",
    tax_provider:null,
    tax_provider_api_key:"",
    tax_provider_org_id:"",
    payabli_paypoint:"",
    apple_pay_enabled:false,
    google_pay_enabled:false,
    gbp_review_url:"",
    quick_send_delivery_charge:"",
    firstName:"",
    lastName:"",
    username:"",
    password:"",
    countryCode:"",
    mobile:"",
    email:"",
    timezone: ""
  });
  const [isEditMode, setIsEditMode] = useState(props.module == "edit-store" ? true : false);
  const [title, setTitle] = useState(null);
  const [local_phone1, setLocalPhone1] = useState("");
  const [local_phone2, setLocalPhone2] = useState("");
  const [fax, setFax] = useState("");
  const [email_id_main, setEmailIdMain] = useState("");
  const [email_id_replay_to, setEmailIdReplayTo] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setStateName] = useState("");
  const [state_matches, setStateMatches] = useState("");
  const [zip, setZip] = useState("");
  const [business_hours, setBusiness_hours] = useState("");
  const [location_hours_line1, setLocationHoursLine1] = useState("");
  const [location_hours_line2, setLocationHoursLine2] = useState("");
  const [instagram_id, setInstagramId] = useState("");
  const [instagram_credentials, setInstagramCredentials] = useState("");
  const [burq_status, setBurqStatus] = useState(false);
  const [onfleet_team_id, setOnfleetTeamID] = useState("")
  const [burq_account_id, setBurqAccountID] = useState("")
  const [is_burq_account, setIsBurqAccount] = useState(false)
  const [apply_daily_overtime, setApplyDailyOvertime] = useState(true);
  const [require_lunch_break, setRequireLunchBreak] = useState(false);
  const [tax_rate, setTaxRate] = useState("");
  const [tax_provider, setTaxProvider] = useState(null);
  const [tax_provider_api_key, setTaxProviderApiKey] = useState("");
  const [tax_provider_org_id, setTaxProviderOrgId] = useState("");
  const [payabli_paypoint, setPayabliPaypoint] = useState("");
  const [apple_pay_enabled, setApplePayEnabled] = useState(false);
  const [google_pay_enabled, setGooglePayEnabled] = useState(false);
  const [gbp_review_url, setGbpReviewUrl] = useState("");
  const [quick_send_delivery_charge, setQuickSendDeliveryCharge] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY_CODE);
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [timezone, setTimezone] = useState(DEFAULT_TIMEZONE);
  const [timezoneList, setTimezoneList] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);

  const [submitStatus, setSubmitStatus] = useState(false);
  const [access, setAccess] = useState({});
  // Store Default Open Close Time
  let storeOpenCloseData = [];
  if(!isEditMode) {
    let default_store_open_close_times = [
      {
        id: 1,
        key: "Sunday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      },
      {
        id: 2,
        key: "Monday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      },
      {
        id: 3,
        key: "Tuesday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      },
      {
        id: 4,
        key: "Wednesday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      },
      {
        id: 5,
        key: "Thursday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      },
      {
        id: 6,
        key: "Friday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      },
      {
        id: 7,
        key: "Saturday",
        store_id: 0,
        open_value: "17:00:00",
        close_value: "24:00:00",
        is_closed: 0
      }
    ];
    // Store Default Open Close Time formatting based on 24 hour format
    storeOpenCloseData = default_store_open_close_times.map((rdata) => {
      if (rdata?.open_value) {
        let openTime = rdata.open_value;

        openTime = openTime.split(":");
        rdata["open_hrs"] = openTime[0];
        if (rdata["open_hrs"].length === 1) rdata["open_hrs"] = "0" + rdata["open_hrs"];
        rdata["open_min"] = openTime[1];
        let twentyFourFormat = moment(rdata["open_hrs"] + ":" + rdata["open_min"], "HH:mm").format("hh:mm A");
        let commonDateTimeConvert = convertDateTime(twentyFourFormat, "format7temp", "hh:mm a")

        rdata["open_hrs"] = commonDateTimeConvert.toFormat("hh");
        rdata["open_min"] = commonDateTimeConvert.toFormat("mm");
        rdata["open_meridiem"] = commonDateTimeConvert.toFormat("a");
      }
      if (rdata?.close_value) {
        let closeTime = rdata.close_value;

        closeTime = closeTime.split(":");
        rdata["close_hrs"] = closeTime[0];
        if (rdata["close_hrs"].length === 1) rdata["close_hrs"] = "0" + rdata["close_hrs"];
        rdata["close_min"] = closeTime[1];
        let twentyFourFormat = moment(rdata["close_hrs"] + ":" + rdata["close_min"], "HH:mm").format("hh:mm A");
        let commonDateTimeConvert = convertDateTime(twentyFourFormat, "format7temp", "hh:mm a")

        rdata["close_hrs"] = commonDateTimeConvert.toFormat("hh");
        rdata["close_min"] = commonDateTimeConvert.toFormat("mm");
        rdata["close_meridiem"] = commonDateTimeConvert.toFormat("a");
      }
      if (rdata?.sameday_cutoff_value) {
        Object.assign(rdata, splitSentinelTime(rdata.sameday_cutoff_value));
      } else {
        rdata["cutoff_hrs"] = "";
        rdata["cutoff_min"] = "";
        rdata["cutoff_meridiem"] = "";
      }
      return rdata;
    });
  }
  const [storeOpenCloseInfo, setStoreOpenCloseInfo] = useState(storeOpenCloseData);

  useEffect(() => {
    handleGetTimezones();
  }, []);

  useEffect(() => {
    if(isEditMode) {
      handleGetDesignerSetting();
    }
  }, [isEditMode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(getModuleAccess, [modules]);  

  const onChange = async (type, value) => {
    if (type === "title") setTitle(value);
    if (type === "fax") {
      if (value.length <= 10) {
        setFax(value);
      }
    }
    if (type === "email_id_main") setEmailIdMain(value);
    if (type === "email_id_replay_to") setEmailIdReplayTo(value);
    if (type === "address1") setAddress1(value);
    if (type === "address2") setAddress2(value);
    if (type === "city") setCity(value);
    if (type === "country") setCountry(value);
    if (type === "state") setStateName(value);
    if (type === "state_matches") setStateMatches(value);
    if (type === "zip") setZip(value);
    if (type === "business_hours") setBusiness_hours(value);
    if (type === "location_hours_line1") setLocationHoursLine1(value);
    if (type === "location_hours_line2") setLocationHoursLine2(value);
    if (type === "instagram_id") setInstagramId(value);
    if (type === "instagram_credentials") setInstagramCredentials(value);
    if (type === "burq_status") {
      await updateStoreWiseBurqStatus({burq_status : value});
      setBurqStatus(value);
    }
    if(type === "onfleet_team_id") setOnfleetTeamID(value)
    if(type === "burq_account_id") setBurqAccountID(value)
    if(type === "is_burq_account") setIsBurqAccount(value)
    if(type === "apply_daily_overtime") setApplyDailyOvertime(value)
    if(type === "require_lunch_break") setRequireLunchBreak(value)
    if(type === "tax_rate") setTaxRate(value);
    if(type === "tax_provider") setTaxProvider(value);
    if(type === "tax_provider_api_key") setTaxProviderApiKey(value);
    if(type === "tax_provider_org_id") setTaxProviderOrgId(value);
    if(type === "payabli_paypoint") setPayabliPaypoint(value);
    if(type === "apple_pay_enabled") setApplePayEnabled(value);
    if(type === "google_pay_enabled") setGooglePayEnabled(value);
    if(type === "gbp_review_url") setGbpReviewUrl(value);
    if(type === "quick_send_delivery_charge") setQuickSendDeliveryCharge(value);
    if(type === "firstName") setFirstName(value);
    if(type === "lastName") setLastName(value);
    if(type === "username") setUsername(value);
    if(type === "password") setPassword(value);
    if(type === "mobile") setMobile(value);
    if(type === "countryCode") setCountryCode(value);
    if(type === "email") setEmail(value);
    if(type === "timezone") setTimezone(value);
    if (type) {
      storeSettingInfo[type] = value;
      setStoreSettingInfo(storeSettingInfo);
    }
  };

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.CONFIG_STORE_SETTING);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      window.location.href = "/dashboard";
    }
  }

  const handleGetDesignerSetting = async () => {
    setIsLoading(true);
    //       "storeSettingInfo"
    let response = await storeDetails();
    if (response && response.status === 200) {
      if (response.data.data["title"])
        setTitle(response.data.data["title"]);
      if (response.data.data["local_phone1"])
        setLocalPhone1(response.data.data["local_phone1"]);
      if (response.data.data["local_phone2"])
        setLocalPhone2(response.data.data["local_phone2"]);
      if (response.data.data["fax"])
        setFax(response.data.data["fax"]);
      if (response.data.data["email_id_main"])
        setEmailIdMain(response.data.data["email_id_main"]);
      if (response.data.data["email_id_replay_to"])
        setEmailIdReplayTo(response.data.data["email_id_replay_to"]);
      if (response.data.data["address1"])
        setAddress1(response.data.data["address1"]);
      if (response.data.data["address2"])
        setAddress2(response.data.data["address2"]);
      if (response.data.data["city"])
        setCity(response.data.data["city"]);
      if (response.data.data["country"])
        setCountry(response.data.data["country"]);
      if (response.data.data["state"])
        setStateName(response.data.data["state"]);
      if (response.data.data["state_matches"])
        setStateMatches(response.data.data["state_matches"]);
      if (response.data.data["zip"])
        setZip(response.data.data["zip"]);
      if (response.data.data["onfleet_team_id"])
        setOnfleetTeamID(response.data.data["onfleet_team_id"]);
      if (response.data.data["burq_account_id"])
        setBurqAccountID(response.data.data["burq_account_id"]);
      if (response.data.data["is_burq_account"])
        setIsBurqAccount(response.data.data["is_burq_account"]);
      setApplyDailyOvertime(!!response.data.data["apply_daily_overtime"]);
      setRequireLunchBreak(!!response.data.data["require_lunch_break"]);
      if (response.data.data["tax_rate"])
        setTaxRate(response.data.data["tax_rate"]);
      if (response.data.data["tax_provider"])
        setTaxProvider(response.data.data["tax_provider"]);
      if (response.data.data["tax_provider_api_key"])
        setTaxProviderApiKey(response.data.data["tax_provider_api_key"]);
      if (response.data.data["tax_provider_org_id"])
        setTaxProviderOrgId(response.data.data["tax_provider_org_id"]);
      if (response.data.data["payabli_paypoint"])
        setPayabliPaypoint(response.data.data["payabli_paypoint"]);
      setApplePayEnabled(!!response.data.data["apple_pay_enabled"]);
      setGooglePayEnabled(!!response.data.data["google_pay_enabled"]);
      if (response.data.data["gbp_review_url"])
        setGbpReviewUrl(response.data.data["gbp_review_url"]);
      setQuickSendDeliveryCharge(response.data.data["quick_send_delivery_charge"] ?? "");
      if (response.data.data["business_hours"])
        setBusiness_hours(response.data.data["business_hours"]);
      if (response.data.data["location_hours_line1"])
        setLocationHoursLine1(response.data.data["location_hours_line1"]);
      if (response.data.data["location_hours_line2"])
        setLocationHoursLine2(response.data.data["location_hours_line2"]);
      if (response.data.data["instagram_id"])
        setInstagramId(response.data.data["instagram_id"]);
      if (response.data.data["instagram_credentials"])
        setInstagramCredentials(
          response.data.data["instagram_credentials"]
        );
      if(response.data.data["store_settings_openclose_times"]){
        let store_open_close_times = response.data.data["store_settings_openclose_times"];
        let storeSettingsOpenCloseTimesObj = await store_open_close_times.map((rdata) => {
          if (rdata?.open_value) {
            let openTime = rdata.open_value;

            openTime = openTime.split(":");
            rdata["open_hrs"] = openTime[0];
            if (rdata["open_hrs"].length === 1) rdata["open_hrs"] = "0" + rdata["open_hrs"];
            rdata["open_min"] = openTime[1];
            let twentyFourFormat = moment(rdata["open_hrs"] + ":" + rdata["open_min"], "HH:mm").format("hh:mm A");
            let commonDateTimeConvert = convertDateTime("20260101 " + twentyFourFormat, "format7temp", "yyyyMMdd hh:mm a")

            rdata["open_hrs"] = commonDateTimeConvert.toFormat("hh");
            rdata["open_min"] = commonDateTimeConvert.toFormat("mm");
            rdata["open_meridiem"] = commonDateTimeConvert.toFormat("a");
          }
          if (rdata?.close_value) {
            let closeTime = rdata.close_value;

            closeTime = closeTime.split(":");
            rdata["close_hrs"] = closeTime[0];
            if (rdata["close_hrs"].length === 1) rdata["close_hrs"] = "0" + rdata["close_hrs"];
            rdata["close_min"] = closeTime[1];
            let twentyFourFormat = moment(rdata["close_hrs"] + ":" + rdata["close_min"], "HH:mm").format("hh:mm A");
            let commonDateTimeConvert = convertDateTime("20260101 " + twentyFourFormat, "format7temp", "yyyyMMdd hh:mm a")

            rdata["close_hrs"] = commonDateTimeConvert.toFormat("hh");
            rdata["close_min"] = commonDateTimeConvert.toFormat("mm");
            rdata["close_meridiem"] = commonDateTimeConvert.toFormat("a");
          }
          if (rdata?.sameday_cutoff_value) {
            Object.assign(rdata, splitSentinelTime(rdata.sameday_cutoff_value));
          } else {
            rdata["cutoff_hrs"] = "";
            rdata["cutoff_min"] = "";
            rdata["cutoff_meridiem"] = "";
          }
          return rdata;
        });
        setStoreOpenCloseInfo(storeSettingsOpenCloseTimesObj);
      }
      if (response.data.data["burq_status"]) setBurqStatus(response.data.data["burq_status"]);
      if (response.data.data["timezone"]) setTimezone(response.data.data["timezone"]);
      setStoreSettingInfo(response.data.data);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const handleSubmitClick = async (event) => {
    let zipVal = Number(zip);
    if(!isEditMode){
      if(!title ||
        !email_id_main ||
        !address1 ||
        !city ||
        !country ||
        !state ||
        !state_matches ||
        !zip ||
        !business_hours ||
        !instagram_id ||
        !tax_rate ||
        !firstName ||
        !lastName ||
        !username ||
        !password ||
        !email){
          event.preventDefault();
          setSubmitStatus(true);
          return;       
      }
      if (!storeSettingInfo) {
        showToastMessage(
          undefined,
          "Please enter max allocation",
          "error",
          false
        );
        event.preventDefault();
      } else if (email_id_main && !checkValidEmailId(email_id_main)) {
        showToastMessage(
          undefined,
          "You have entered an invalid main email address!",
          "error",
          false
        );
        event.preventDefault();
      } else if (zip && zip <= 0) {
        showToastMessage(
          undefined,
          "Please enter valid positive values only in zip code",
          "error",
          false
        );
        event.preventDefault();
      } else if ((zip && zip.length < 5) || zip.length > 5) {
        showToastMessage(
          undefined,
          "Please enter valid zip code with 5 digit length.",
          "error",
          false
        );
        event.preventDefault();
      } else if (zip && _.isInteger(zipVal) == false) {
        showToastMessage(
          undefined,
          "Please enter valid integer number",
          "error",
          false
        );
        event.preventDefault();
      } else if (!tax_rate || isNaN(tax_rate) || (tax_rate && tax_rate <= 0)) {
        showToastMessage(
          undefined,
          "Please enter valid tax rate greater than 0",
          "error",
          false
        );
        event.preventDefault();
      } else if (!storeSettingInfo.local_phone1 || (storeSettingInfo.local_phone1 && storeSettingInfo.local_phone1.length <= 10 && storeSettingInfo.local_phone1.length >= 15)) {
        showToastMessage(
          undefined,
          "Please enter valid local phone",
          "error",
          false
        );
        event.preventDefault();
      } else if (!mobile || (mobile && mobile.length <= 10 && mobile.length >= 15)) {
        showToastMessage(
          undefined,
          "Please enter valid mobile number",
          "error",
          false
        );
        event.preventDefault();
      }else {
        event.preventDefault();
  
        if (
          title &&
          storeSettingInfo.local_phone1 &&
          email_id_main &&
          address1 &&
          city &&
          country &&
          state &&
          state_matches &&
          zip &&
          business_hours &&
          instagram_id &&
          firstName &&
          lastName &&
          username &&
          password &&
          mobile &&
          email
        ) {
  
          setIsLoading(true);
          storeSettingInfo.fax = fax.replace(/[#_ ]/g, "");
          storeSettingInfo.store_settings_openclose_times = storeOpenCloseInfo;
          storeSettingInfo.timezone = storeSettingInfo.timezone || DEFAULT_TIMEZONE;
          let response =  await addStoreDetails(storeSettingInfo);
          if (response && response.status === 200) {
            showToastMessage(undefined, response.data.message, "success", false);
            setSubmitStatus(false);

            // Get user profile and set user assigned store and default selected store save in local storage
            let responseProfile = await getProfile();
            if (responseProfile && responseProfile.status === 200) {
              let assignStore=[];
              responseProfile.data.data.user_assign_stores.map((item)=>{
                return assignStore.push(item.store)
              })
              assignStore.sort((prev,next)=>prev.id-next.id)
              localStorage.setItem("assignStore", JSON.stringify(assignStore));
              localStorage.setItem("selectedStore",response.data.data.id)
              localStorage.setItem("storeTimezone",response.data.data.timezone || DEFAULT_TIMEZONE)
              navigate(`/settings/store-setting`);
              window.location.reload();
            };
          } else {
            showToastMessage(undefined, response.data.message, "error", false);
          }
          setIsLoading(false);
        }
      }
    } else {
      if(!title ||
        !email_id_main ||
        !address1 ||
        !city ||
        !country ||
        !state ||
        !zip ||
        !business_hours ||
        !instagram_id ||
        !tax_rate){
          event.preventDefault();
          setSubmitStatus(true);
          return;       
      }

      if (!storeSettingInfo) {
        showToastMessage(
          undefined,
          "Please enter max allocation",
          "error",
          false
        );
        event.preventDefault();
      } else if (email_id_main && !checkValidEmailId(email_id_main)) {
        showToastMessage(
          undefined,
          "You have entered an invalid main email address!",
          "error",
          false
        );
        event.preventDefault();
      } else if (zip && zip <= 0) {
        showToastMessage(
          undefined,
          "Please enter valid positive values only in zip code",
          "error",
          false
        );
        event.preventDefault();
      } else if ((zip && zip.length < 5) || zip.length > 5) {
        showToastMessage(
          undefined,
          "Please enter valid zip code with 5 digit length.",
          "error",
          false
        );
        event.preventDefault();
      } else if (zip && _.isInteger(zipVal) == false) {
        showToastMessage(
          undefined,
          "Please enter valid integer number",
          "error",
          false
        );
        event.preventDefault();
      } else if (!tax_rate || isNaN(tax_rate) || (tax_rate && tax_rate <= 0)) {
          showToastMessage(
            undefined,
            "Please enter valid tax rate greater than 0",
            "error",
            false
          );
          event.preventDefault();
      }else {
        event.preventDefault();
  
        if (
          title &&
          local_phone1 &&
          email_id_main &&
          address1 &&
          city &&
          country &&
          state &&
          zip &&
          business_hours &&
          instagram_id
        ) {
  
          setIsLoading(true);
          storeSettingInfo.fax = fax.replace(/[#_ ]/g, "");
          storeSettingInfo.store_settings_openclose_times = storeOpenCloseInfo;
          let response = await updateStoreDetails(storeSettingInfo);
          if (response && response.status === 200) {
            showToastMessage(undefined, response.data.message, "success", false);
  
            setSubmitStatus(false);
  
            if(localStorage.getItem("storeTimezone") !== storeSettingInfo.timezone){
              localStorage.setItem("storeTimezone", storeSettingInfo.timezone)
              window.location.reload(); 
            } else {
              handleGetDesignerSetting();
            }
          } else {
            showToastMessage(undefined, response.data.message, "error", false);
          }
          setIsLoading(false);
        }
      }
    }
  };

  const handleGetTimezones = async () => {
    const response = await getTimezones();

    if (response && response.status === 200) {
      response.data.data.map((timezoneObj) => {
        timezoneObj.id = timezoneObj.zone;
        return timezoneObj;
      });
      setTimezoneList(response.data.data);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };


  const handleConfirmClick = async (event) => {
    // Only perform zip code validation for new store creation (not edit mode)
    if(!isEditMode){
      let zipVal = Number(zip);
      if(!zipVal){
        showToastMessage(
          undefined,
          "Please enter valid zip code",
          "error",
          false
        );
        return;
      } else if(zipVal <= 0) {
        showToastMessage(
          undefined,
          "Please enter valid positive values only in zip code",
          "error",
          false
        );
        return;
      } else if ((zip && zip.length < 5) || zip.length > 5) {
        showToastMessage(
          undefined,
          "Please enter valid zip code with 5 digit length.",
          "error",
          false
        );
        return;
      } else if (zip && _.isInteger(zipVal) == false) {
        showToastMessage(
          undefined,
          "Please enter valid integer number",
          "error",
          false
        );
        return;
      }
      // Check if a store with the same zip code already exists
      const zipCodeResponse = await checkStoreWithSameZipCode({zipcode : zip});
      
      if(zipCodeResponse && zipCodeResponse.status === 200){
        // If a store with same zip code exists, show warning modal
        if(!zipCodeResponse.data.data.is_available){
          setShowWarningModal(true);
          return;
        }else{
          // No store with same zip code, proceed with form submission
          handleSubmitClick(event);
        }
      }else{
        showToastMessage(
          undefined, 
          zipCodeResponse?.data?.message || "Something went wrong while checking zip code", 
          "error", 
          false
        );
      }
    }else{
      // If API call fails, proceed with form submission anyway
      handleSubmitClick(event);
    }
  }
  

  return (
    <React.Fragment>
      {showWarningModal && (
        <Warning
          btn1_title={"Continue"}
          btn2_title={"Cancel"}
          handleCancelClick={() => setShowWarningModal(false)}
          showModal={showWarningModal}
          handleSubmitClick={(e) => {
            handleSubmitClick(e)
            setShowWarningModal(false)
          }}
        message={
          "There's already another store with this same zip code."
        }
        message2={"Are you sure you want to continue?"}
        title={"Warning"}
          key={"create_new_store_warning_with_same_zip_code"}
        />
      )}
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Basic Information</h3>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Text
            type="text"
            label="Title"
            value={title}
            required={true}
            id="title"
            submitStatus={submitStatus}
            onChange={(data) => onChange("title", data)}
          />
        </div>
        <div className="col-md-6">
          <Select
            label="Timezone"
            value={timezone}
            onChange={(data) => onChange("timezone", data)}
            options={timezoneList}
            disabled={false}
          />
        </div>
      </div>
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Contact Information</h3>
      </div>
      <div className="row">
        <div className="col-md-4">
          <PhoneNumber
            countryCode={DEFAULT_COUNTRY_CODE_NAME}
            specialLabel={"Local Phone"}
            initValue={local_phone1}
            fieldName={`Local Phone`}
            onChange={(phone, countryData, event, formatedValue) => {
              onChange("local_phone1", formatedValue);
            }}
          />
        </div>
        <div className="col-md-4">
          <PhoneNumber
            countryCode={DEFAULT_COUNTRY_CODE_NAME}
            specialLabel={"Local Phone 2"}
            initValue={local_phone2}
            fieldName={`Local Phone 2`}
            onChange={(phone, countryData, event, formatedValue) => {
              onChange("local_phone2", formatedValue);
            }}
          />
        </div>
        <div className="col-md-4">
          <Text
            type="text"
            label="Fax"
            value={formatUsPhone(fax)}
            id="fax"
            submitStatus={submitStatus}
            onChange={(data) => onChange("fax", data)}
          />
        </div>
        <div className="col-md-4">
          <Text
            type="text"
            label="Main Email"
            value={email_id_main}
            required={true}
            id="main"
            submitStatus={submitStatus}
            onChange={(data) => onChange("email_id_main", data)}
          />
        </div>
        <div className="col-md-4">
          <Text
            type="emain"
            label="Reply To Email"
            value={email_id_replay_to}
            id="reply_to"
            submitStatus={submitStatus}
            onChange={(data) => onChange("email_id_replay_to", data)}
          />
        </div>
      </div>
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Address</h3>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Text
            type="text"
            label="Address"
            value={address1}
            required={true}
            id="address"
            submitStatus={submitStatus}
            onChange={(data) => onChange("address1", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="Address 2"
            value={address2}
            id="address_2"
            submitStatus={submitStatus}
            onChange={(data) => onChange("address2", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="City"
            value={city}
            required={true}
            id="city"
            submitStatus={submitStatus}
            onChange={(data) => onChange("city", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="Country"
            value={country}
            required={true}
            id="country"
            submitStatus={submitStatus}
            onChange={(data) => onChange("country", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="State"
            value={state}
            required={true}
            id="state"
            submitStatus={submitStatus}
            onChange={(data) => onChange("state", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="State Matches"
            value={state_matches}
            required={true}
            id="state_matches"
            submitStatus={submitStatus}
            onChange={(data) => onChange("state_matches", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="number"
            label="Zip"
            value={zip}
            required={true}
            id="zip"
            submitStatus={submitStatus}
            onChange={(data) => onChange("zip", data)}
          />
        </div>
      </div>
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Other Information</h3>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Text
            type="text"
            label="Business Hours"
            value={business_hours}
            required={true}
            id="business_hours"
            submitStatus={submitStatus}
            onChange={(data) => onChange("business_hours", data)}
          />
        </div>
        <div className="col-md-6"></div>
        <div className="col-md-6">
          <Text
            type="text"
            label="Location Hours Line 1"
            value={location_hours_line1}
            id="location_hours_line1"
            submitStatus={submitStatus}
            onChange={(data) => onChange("location_hours_line1", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="Location Hours Line 2"
            value={location_hours_line2}
            id="location_hours_line_2"
            submitStatus={submitStatus}
            onChange={(data) => onChange("location_hours_line2", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="Google Review URL"
            value={gbp_review_url}
            id="gbp_review_url"
            submitStatus={submitStatus}
            onChange={(data) => onChange("gbp_review_url", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="number"
            label="2Tap Delivery Charge"
            value={quick_send_delivery_charge}
            id="quick_send_delivery_charge"
            onChange={(data) => onChange("quick_send_delivery_charge", data)}
          />
        </div>
      </div>
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Instagram Information</h3>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Text
            type="text"
            label="ID"
            value={instagram_id}
            required={true}
            id="instagram_id"
            submitStatus={submitStatus}
            onChange={(data) => onChange("instagram_id", data)}
          />
        </div>
        <div className="col-md-6">
          <Text
            type="text"
            label="Credentials"
            value={instagram_credentials}
            id="instagram_credentials"
            submitStatus={submitStatus}
            onChange={(data) => onChange("instagram_credentials", data)}
          />
        </div>
      </div>


      <StoreSettingOpenCloseTime storeOpenCloseInfo={storeOpenCloseInfo} setStoreOpenCloseInfo={setStoreOpenCloseInfo} />

      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">On-Demand Status</h3>
      </div>
      <div className="row">
        <div className={`col-md-6 ${style.burq_status_toggle_button}`}>
          <SwitchBox
            value={burq_status}
            disabled={false}
            onChange={(data) => onChange("burq_status", data)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">Onfleet Team ID</h3> 
          </div>
          <Text
            type="text"
            label="Onfleet Team ID"
            value={onfleet_team_id}
            id="onfleet_team_id"
            submitStatus={submitStatus}
            onChange={(data) => onChange("onfleet_team_id", data)}
          />
        </div>
        <div className="col-md-2">
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">Burq Account</h3> 
          </div>
          <SwitchBox
            value={is_burq_account}
            disabled={false}
            onChange={(data) => onChange("is_burq_account", data)}
          />
        </div>
        <div className="col-md-4">
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">{is_burq_account ? "Burq Account ID" : "Burq Store ID"}</h3> 
          </div>
          <Text
            type="text"
            label={is_burq_account ? "Burq Account ID" : "Burq Store ID"}
            value={burq_account_id}
            id="burq_account_id"
            submitStatus={submitStatus}
            onChange={(data) => onChange("burq_account_id", data)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">Tax Rate</h3>
          </div>
          <p className="text-muted small mb-2">
            Flat tax percentage used when the tax provider is set to Local. Also used as a fallback rate if a Kintsugi API call fails.
          </p>
          <Text
            type="text"
            label="Tax Rate"
            value={tax_rate}
            required={true}
            id="tax_rate"
            submitStatus={submitStatus}
            onChange={(data) => onChange("tax_rate", data)}
          />
        </div>
      </div>
      {/* TAX PROVIDER */}
      <div className="row">
        <div className="col-md-6">
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">Tax Provider</h3>
          </div>
          <p className="text-muted small mb-2">
            <strong>Local (flat rate)</strong> &mdash; Tax is calculated using the Tax Rate percentage above. No external API calls are made.<br />
            <strong>Local (flat rate + delivery)</strong> &mdash; Same as Local, but the delivery charge is also taxed at the flat Tax Rate.<br />
            <strong>Kintsugi (tax calculation only)</strong> &mdash; Tax is calculated via the Kintsugi API based on the delivery address. Falls back to the flat Tax Rate if the API call fails. Orders are not reported to Kintsugi for filing.<br />
            <strong>Kintsugi (full)</strong> &mdash; Same tax calculation as above, plus orders are committed and cancellations are reported to Kintsugi for tax remission and filing.
          </p>
          <Select
            value={tax_provider}
            id="tax_provider"
            submitStatus={submitStatus}
            onChange={(data) => onChange("tax_provider", data)}
            options={[
              { id: null, title: "Local (flat rate)" },
              { id: "manual_delivery", title: "Local (flat rate + delivery)" },
              { id: "kintsugi_estimate", title: "Kintsugi (tax calculation only)" },
              { id: "kintsugi", title: "Kintsugi (full — calculation + remission)" },
            ]}
          />
        </div>
      </div>
      {(tax_provider === "kintsugi" || tax_provider === "kintsugi_estimate") && (
        <div className="row">
          <div className="col-md-6">
            <div className="d-md-flex align-items-md-center mt-4 mb-1">
              <h3 className="bold">Kintsugi API Key</h3>
            </div>
            <p className="text-muted small mb-2">
              Leave blank to use the default credentials from the server environment.
            </p>
            <Text
              type="text"
              label="API Key"
              value={tax_provider_api_key}
              id="tax_provider_api_key"
              submitStatus={submitStatus}
              onChange={(data) => onChange("tax_provider_api_key", data)}
            />
          </div>
          <div className="col-md-6">
            <div className="d-md-flex align-items-md-center mt-4 mb-1">
              <h3 className="bold">Kintsugi Organization ID</h3>
            </div>
            <p className="text-muted small mb-2">
              Leave blank to use the default credentials from the server environment.
            </p>
            <Text
              type="text"
              label="Organization ID"
              value={tax_provider_org_id}
              id="tax_provider_org_id"
              submitStatus={submitStatus}
              onChange={(data) => onChange("tax_provider_org_id", data)}
            />
          </div>
        </div>
      )}
      {/* PAYABLI */}
      <div className="row">
        <div className="col-md-6">
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">Payabli Paypoint</h3> 
          </div>
          <Text
            type="text"
            label="Payabli Paypoint"
            value={payabli_paypoint}
            id="payabli_paypoint"
            submitStatus={submitStatus}
            onChange={(data) => onChange("payabli_paypoint", data)}
          />
        </div>
      </div>

      {/* PAYROLL / TIMECLOCK */}
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Payroll / Timeclock</h3>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="d-md-flex align-items-md-center mt-2 mb-1">
            <h3 className="bold">Daily Overtime (over 8 hrs/day)</h3>
          </div>
          <p className="text-muted small mb-2">
            When on, hours past 8 in a day go to OT1/OT2 (California-style). When off, overtime is weekly-only (FLSA) at the 40 hr/week boundary.
          </p>
          <SwitchBox
            value={apply_daily_overtime}
            disabled={false}
            onChange={(data) => onChange("apply_daily_overtime", data)}
          />
        </div>
        <div className="col-md-6">
          <div className="d-md-flex align-items-md-center mt-2 mb-1">
            <h3 className="bold">Require 30-Minute Meal Break</h3>
          </div>
          <p className="text-muted small mb-2">
            When on, a clock-in within 30 minutes of the prior clock-out is flagged as an early break.
          </p>
          <SwitchBox
            value={require_lunch_break}
            disabled={false}
            onChange={(data) => onChange("require_lunch_break", data)}
          />
        </div>
      </div>

      {/* WALLET PAYMENTS */}
      <div className="d-md-flex align-items-md-center mt-4 mb-1">
        <h3 className="bold">Wallet Payments</h3>
      </div>
      <div className="row">
        <div className="col-md-6">
          <label className="mb-1">Apple Pay enabled</label>
          <SwitchBox
            value={apple_pay_enabled}
            disabled={false}
            onChange={(data) => onChange("apple_pay_enabled", data)}
          />
        </div>
        <div className="col-md-6">
          <label className="mb-1">Google Pay enabled</label>
          <SwitchBox
            value={google_pay_enabled}
            disabled={false}
            onChange={(data) => onChange("google_pay_enabled", data)}
          />
        </div>
      </div>

      {!isEditMode && (
        <>
          <div className="d-md-flex align-items-md-center mt-4 mb-1">
            <h3 className="bold">Designer Information</h3>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Text
                type="text"
                label="First Name"
                value={firstName}
                required={true}
                submitStatus={submitStatus}
                onChange={(data) => onChange("firstName", data)}
              />
            </div>
            <div className="col-md-6">
              <Text
                type="text"
                label="Last Name"
                value={lastName}
                required={true}
                submitStatus={submitStatus}
                onChange={(data) => onChange("lastName", data)}
              />
            </div>
            <div className="col-md-6">
              <Text
                type="text"
                label="Username"
                value={username}
                required={true}
                submitStatus={submitStatus}
                onChange={(data) => onChange("username", data)}
              />
            </div>
            <div className="col-md-6">
              <Text
                type="password"
                label="Password"
                value={password}
                required={true}
                submitStatus={submitStatus}
                onChange={(data) => onChange("password", data)}
              />
            </div>
            <div className="col-md-6">
              <PhoneNumber
                countryCode={DEFAULT_COUNTRY_CODE_NAME}
                specialLabel={"Mobile"}
                initValue={countryCode + mobile}
                fieldName={`Mobile`}
                onChange={(phone, countryData, event, formatedValue) => {
                  let countryCode = "+" + countryData.dialCode;
                  let finalMobileNum = formatedValue
                    ? formatedValue?.split(countryCode)[1]?.trim()
                    : "";
                  onChange("countryCode", countryCode);
                  onChange("mobile", finalMobileNum);
                }}
              />
            </div>
            <div className="col-md-6">
              <Text
                type="email"
                label="Email"
                value={email}
                required={true}
                submitStatus={submitStatus}
                onChange={(data) => onChange("email", data)}
              />
            </div>
          </div>
        </>
      )}      

      <div className="d-block text-left mt-5 mb-4">
        {access.write_access && (
          <button
            onClick={(e) => handleConfirmClick(e)}
            className="btn pink-btn bold"
          >
            Save
          </button>
        )}
      </div>
    </React.Fragment>
  );
};
export default InfoSettings;
